import React, { useState } from "react";
import { HashLink as Link } from "react-router-hash-link";
import {
  Box,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MenuIcon from "@mui/icons-material/Menu";
import { useTheme } from "@mui/material";
import LogoZDoctors from '../../../assets/ZdoctorsLogo.svg'
import BlueButton from "../blueButton";

const useStyles = makeStyles((theme) => ({
  headerBox: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "0px 4px 5px 0px rgba(0, 0, 0, 0.10)",
    padding: theme.spacing(2, 5),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1, 2),
    },
  },
  headerLinks: {
    color: "#39ADC4",
    fontSize: "20px",
    cursor: "pointer",
    textDecoration: "none",
    whiteSpace: "nowrap",
    marginRight: '20px',
    "&:hover": {
      opacity: 0.7,
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  headerLinksList: {
    color: "#39ADC4",
    fontSize: "20px",
    cursor: "pointer",
    "&:hover": {
      opacity: 0.7,
    },
  },
  zDoctorsLogo: {
    cursor: "pointer",
    maxWidth: "100%",
    height: "auto",
    width: "auto",
    "&:hover": {
      opacity: 0.7,
    },
    [theme.breakpoints.down("sm")]: {
      width: "100px",
    },
  },
  headerButtons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    width: "75%",
    [theme.breakpoints.down("sm")]: {
      width: "auto",
    },
  },
  menuButton: {
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
    marginLeft: theme.spacing(1),
  },
  list: {
    width: 200,
  },
  fullList: {
    width: "auto",
  },
}));

function PageHeader({
  featuresSectionRef,
  casesSectionRef,
  pricingSectionRef,
  is
}) {
  const classes = useStyles();
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const scrollToSection = (sectionRef) => {
    if (sectionRef && sectionRef.current) {
      sectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setMobileOpen(open);
  };

  const list = () => (
    <div className={classes.list} role="presentation" onClick={toggleDrawer(false)} onKeyDown={toggleDrawer(false)}>
      <List>
        <Link
          to="/#cases"
          smooth
          key={"Cases"}
          style={{ justifyContent: "flex-end" }}
          onClick={() => scrollToSection(casesSectionRef)}
        >
          <ListItem>
            <Typography className={classes.headerLinksList}>
              {"Cases"}
            </Typography>
          </ListItem>
        </Link>
        <Link
          to="/#pricing"
          smooth
          key={"Preço"}
          style={{ justifyContent: "flex-end" }}
          onClick={() => scrollToSection(pricingSectionRef)}
        >
          <ListItem>
            <Typography className={classes.headerLinksList}>
              {"Preço"}
            </Typography>
          </ListItem>
        </Link>
      </List>
    </div>
  );

  return (
    <Box className={classes.headerBox}>
      <img src={LogoZDoctors} alt="Logo Z-Doctors" className={classes.zDoctorsLogo} onClick={() => {
        window.open("/", '_self');
      }} />
      {!is && (
      <Box className={classes.headerButtons}>
        <Link
          to="/#features"
          smooth
          className={classes.headerLinks}
          onClick={() => scrollToSection(featuresSectionRef)}
          data-aos={isMobile ? "" : "fade-in"}
          data-aos-delay="300"
        >
          Funcionalidades
        </Link>
        <Link
          className={classes.headerLinks}
          onClick={() => scrollToSection(casesSectionRef)}
          to="/#cases"
          smooth
          data-aos={isMobile ? "" : "fade-in"}
          data-aos-delay="400"
        >
          Cases
        </Link>
        <Link
          to="/#pricing"
          smooth
          className={classes.headerLinks}
          onClick={() => scrollToSection(pricingSectionRef)}
          data-aos={isMobile ? "" : "fade-in"}
          data-aos-delay="500"
        >
          Preço
        </Link>
        <BlueButton
          text="Teste agora"
          delay={"600"}
        />
        <IconButton
          edge="start"
          className={classes.menuButton}
          color="inherit"
          aria-label="menu"
          onClick={toggleDrawer(true)}
        >
          <MenuIcon color="#4E5258" />
        </IconButton>
        <Drawer anchor="right" open={mobileOpen} onClose={toggleDrawer(false)}>
          {list()}
        </Drawer>
      </Box> )}
    </Box>
  );
}

export default PageHeader;
